import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import { parseInt } from "lodash";


export default {
    
    getAll,
    editData,
    getOperationEntitiesByGroupID,
    getDivisionsByOperationEntityID,
    getAttendanceReportDaily,
    GetEntityTypeByOperationEntityID
    
};

async function getAll(){
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function editData(data) {
    data.groupName = data.groupName.trim();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/Group/UpdateGroup', null, data);
    return response;
}

async function getOperationEntitiesByGroupID(id) {
    var operationEntitiesArray = [];
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + parseInt(id));
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            operationEntitiesArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return operationEntitiesArray;
}

async function getDivisionsByOperationEntityID(id) {
    var divisionsArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + parseInt(id));
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionsArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionsArray;
}


async function getAttendanceReportDaily(data) {
        var attendance = {
        operationEntityID : parseInt(data.operationEntityID),
        divisionID : parseInt(data.divisionID),
        createdDate : (data.date),
      
    }
    var response = await CommonPost('/api/AttendanceReportDaily/GetAttendanceReportDaily', null, attendance);
    return response.data;
    
}

async function GetEntityTypeByOperationEntityID(operationEntityId , groupId){
    const response = await CommonGet('/api/OperationEntity/GetEntityTypeByOperationEntityIDandGroupID', 'operationEntityID=' + parseInt(operationEntityId) + '&groupID=' + parseInt(groupId));
    return response.data;
}


